module.exports = __webpack_public_path__ + "static/media/tkg-rom.ff45b4f4.png";